module.exports = __webpack_public_path__ + "static/media/NPTEL.19157364.png";